(function ($) { 

  //  Reverse Recruiting Page
  if ($(".site-main").hasClass("fmp-rr-packages-page")) {
    sessionStorage.removeItem("fmp_user_detail");

    // $(".fmp-rr-bundle__package-toggle").on("click", function () {
    //   $(this).toggleClass("active");
    //   $(this).closest(".fmp-rr-bundle__package-header").toggleClass("show-text");
    // });

    $(".fmp-rr-bundle__checkout").hide();
    var rrSetItem = { package: "", bundle: "", bundle_addon: "" };
    $(".fmp-rr-checkout").on("click", function (e) {
      e.preventDefault();

      var packageName = $(this).attr("data-package");
      var packageId = $(this).attr("data-package-id");
      // if (packageName == "elite") {
      //   $(".fmp-rr-bundle__priority-service-badge").show();
      //   $("input[name=fmp-rr-bundle-addon]").attr("disabled", true);
      // } else {
      //   $("input[name=fmp-rr-bundle-addon]").attr("disabled", false);
      // }
      rrSetItem["package"] = packageId;
      sessionStorage.setItem("fmp_add_rr_product", JSON.stringify(rrSetItem));
      if ( 'elite-no-timeline' === packageName ) {
        rrGetItem = JSON.parse(sessionStorage.getItem("fmp_add_rr_product"));
        fmpRRAddProduct( rrGetItem );
      }else {
        $(".fmp-rr-bundle").addClass("active");
      }
    });

    $("input[name=fmp-rr-bundle]").on("change", function () {
      var value = $(this).val();
      rrSetItem["bundle"] = value;
      sessionStorage.setItem("fmp_add_rr_product", JSON.stringify(rrSetItem));
      fmpRRAddPrice();
    });

    $("input[name=fmp-rr-bundle-addon]").on("change", function () {
      var value = $(this).val();
      if ($("input[name=fmp-rr-bundle-addon]").is(":checked")) {
        rrSetItem["bundle_addon"] = value;
        sessionStorage.setItem("fmp_add_rr_product", JSON.stringify(rrSetItem));
      } else {
        rrSetItem["bundle_addon"] = "";
        sessionStorage.setItem("fmp_add_rr_product", JSON.stringify(rrSetItem));
      }

      fmpRRAddPrice();
    });

    $(document).mouseup(function (e) {
      var container = $(".fmp-rr-bundle__wrap");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        fmpRemoveBundle();
      }
    });

    $(".fmp-rr-packages-page").on("click", ".fmp-rr-bundle__close", function (e) {
      fmpRemoveBundle();
    });

    function fmpRemoveBundle() {
      $(".fmp-rr-bundle").removeClass("active");

      $("input[name=fmp-rr-bundle]").removeAttr("checked");
      $("input[name=fmp-rr-bundle-addon]").removeAttr("checked");
      $(".fmp-rr-bundle__checkout").hide();
      $(".fmp-rr-bundle__priority-service-badge").hide();
      rrSetItem = { package: "", bundle: "", bundle_addon: "" };
      sessionStorage.setItem("fmp_add_rr_product", JSON.stringify(rrSetItem));
    }

    function fmpRRAddPrice() {
      var rrGetItem = JSON.parse(sessionStorage.getItem("fmp_add_rr_product"));
      var data = {
        action: "fmp_rr_add_price",
        nounce: localized.ajaxnonce,
        rr_product: rrGetItem,
      };

      $.ajax({
        type: "POST",
        dataType: "json",
        url: localized.ajaxurl,
        data: data,
        success: function success(response) {
          $(".fmp-rr-bundle__checkout span").html(
            "Proceed to Checkout (" + response.output + ")"
          );
          $(".fmp-rr-bundle__checkout").show("fast");
        },
      });
    }

    $(".fmp-rr-bundle__checkout-no-bundle, .fmp-rr-bundle__checkout").on(
      "click",
      function (e) {
        e.preventDefault();
        var rrGetItem = null;
        if (e.currentTarget.className == "fmp-rr-bundle__checkout") {
          rrGetItem = JSON.parse(sessionStorage.getItem("fmp_add_rr_product"));
        } else {
          rrSetItem["bundle"] = "";
          rrSetItem["bundle_addon"] = "";
          sessionStorage.setItem("fmp_add_rr_product", JSON.stringify(rrSetItem));
          rrGetItem = JSON.parse(sessionStorage.getItem("fmp_add_rr_product"));
        }
        fmpRRAddProduct( rrGetItem );
      }
    );
  }

  function fmpRRAddProduct( rrGetItem ) {

      var data = {
        action: "fmp_rr_add_to_cart",
        nounce: localized.ajaxnonce,
        rr_product: rrGetItem,
      };

      $.ajax({
        type: "POST",
        dataType: "json",
        url: localized.ajaxurl,
        data: data,
        success: function success(response) {
          if ( response.success && response.data.redirect_url ) {
            setTimeout( function () {
              window.location.href = response.data.redirect_url;
            }, 300 );
          }
        },
      });
  }

  if( $(".fmp-rr-roi").length ){
    $('#rr_roi').on('keyup',function(){
      var num = getNumber($(this).val());
      if(num==0){
        $(this).val('');
      }else{
        $(this).val(num.toLocaleString());
      }
    });

    function getNumber(_str){
      var arr = _str.split('');
      var out = new Array();
      for( var cnt=0; cnt<arr.length; cnt++ ) {
        if( isNaN( arr[cnt] )==false ) {
          out.push( arr[cnt] );
        }
      }
      return Number(out.join(''));
    }

    $(".fmp-rr-roi-form-submit").on( "click", function (e) {
      e.preventDefault();
      var amt = $("#rr_roi").val();
      amt = amt.replace(/,/g, '');
      var targetSalary = 'not-fit';
      
      if( 80000 <= amt ){
        $(".fmp-rr-roi-content").addClass('fmp-rr-roi-max');
        targetSalary = 'fit';
      } else{
        $(".fmp-rr-roi-content").removeClass('fmp-rr-roi-max');
      }

      $(".fmp-rr-roi-result").html('<div class="fmp-rr-roi-result-loader"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve"><path fill="#fff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" /></path></svg></div>');

      var data = {
        action: "fmp_calculate_roi",
        nounce: localized.ajaxnonce,
        amt: amt,
        target_salary: targetSalary,
      };

      $.ajax({
        type: "POST",
        dataType: "json",
        url: localized.ajaxurl,
        data: data,
        success: function success(response) {
          if( response.result ) {
            $(".fmp-rr-roi-result").html(response.result);
          }
        },
      });

    });
  }
})(jQuery);
